import { ElementType, ReactNode } from 'react';

import classNames from 'classnames';

import {
  fontFamily,
  fontWeight,
  headingSizeTrimmed,
  headingSizeUntrimmed,
  tone as headingTone,
} from '../../css/typography.css';

import { Box, BoxProps } from '../Box/Box';

export interface HeadingProps {
  tone?: keyof typeof headingTone;
  level: keyof typeof headingSizeTrimmed;
  weight?: keyof typeof fontWeight;
  align?: BoxProps['textAlign'];
  /** capitalize, uppercase or lowercase the provided text */
  transform?: BoxProps['textTransform'];
  component?: BoxProps['component'];
  children: ReactNode;
  untrimmed?: boolean;
  display?: 'block' | 'inline';
  title?: string;
  className?: string;
}

const resolveComponent = {
  '1': 'h1',
  '2': 'h2',
  '3': 'h3',
  '4': 'h4',
  '5': 'h5',
  '6': 'h6',
};

export const Heading: React.FC<HeadingProps> = ({
  level,
  weight = 'demibold',
  tone = 'neutral',
  component,
  children,
  untrimmed,
  transform,
  align,
  title,
  display = 'block',
  className,
}) => {
  return (
    <Box
      textAlign={align}
      display={display}
      textTransform={transform}
      className={classNames(
        fontFamily,
        fontWeight[weight],
        untrimmed ? headingSizeUntrimmed[level] : headingSizeTrimmed[level],
        headingTone[tone],
        className
      )}
      component={component || (resolveComponent[level] as ElementType)}
      title={title}
    >
      {children}
    </Box>
  );
};
